'use strict';/* global define */define('modules/core/modules/app/services/clamps-version/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["LocalStorage"];
function factory(LocalStorage){// jshint validthis:true
// jshint latedef:false
var CLAMPS_VERSION_STORAGE_NAME='clampsVersion';return{isNewVersion:isNewVersion,get:get};// ---
/**
     * Store the new version number
     *
     * @param {String} newVersion - New clamps version
     *
     * @private
     */function _setVersion(newVersion){LocalStorage.setItem(CLAMPS_VERSION_STORAGE_NAME,newVersion);}/**
     * Determine if we need to update / store the clamps version
     *
     * @param  {String} version - Provided clamps version number
     * @return {Boolean}        - Result whether we should udpate the
     *                            version number or not
     * @tested
     */function isNewVersion(version){var _version=get();if(_version!==null){return _version!==version;}_setVersion(version);return false;}/**
     * Get clamps version
     *
     * @return {String} clamps version
     *
     * @tested
     */function get(){return LocalStorage.getItem(CLAMPS_VERSION_STORAGE_NAME);}}module.exports=factory;});
